// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2k5Jm","body":"styles_body__1if16","caption":"styles_caption__2D0bW"};